(function ($) {
  $('.js-sticky-contact-card-btn').on('click', function (e) {
    e.preventDefault();
    $('.js-sticky-contact-card').toggleClass('is-opened');
  });
})(jQuery);
